import Papa from "papaparse";

export const rapidRailBusService = {
  getShapes: () => parseCsv("/rapid-rail-bus/shapes.txt"),
  getRoutes: () => parseCsv("/rapid-rail-bus/routes.txt"),
  getStops: () => parseCsv("/rapid-rail-bus/stops.txt"),
  getStopTimes: () => parseCsv("/rapid-rail-bus/stop_times.txt"),
  getTrips: () => parseCsv("/rapid-rail-bus/trips.txt"),
  getFrequencies: () => parseCsv("/rapid-rail-bus/frequencies.txt"),
};

async function parseCsv(filePath) {
  try {
    const response = await fetch(filePath);
    const textFile = await response.text();

    const result = await new Promise((resolve, reject) => {
      Papa.parse(textFile, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => resolve(result.data),
        error: (error) => reject(error),
      });
    });

    return result;
  } catch (error) {
    console.error(`Error loading/parsing ${filePath}:`, error);
    return [];
  }
}
